module.exports = __webpack_public_path__ + "static/media/video-poster.e7745be8.png";